<template>
<v-layout>
<v-flex md12>
<v-expansion-panel-content :data-cotrustor-header="cotrustor.id">
  <template v-slot:header>
  <div>
   <v-icon>account_circle</v-icon> {{cotrustor.name || "Co-Trustor #"+cotrustor.id}}
     <span>
      <v-btn :data-btn="'delete-co-trustor-'+cotrustor.id" @click="deleteItem(cotrustor)" flat icon color="red" align-end>
      <v-icon>delete</v-icon>
      </v-btn>
    </span>
  </div>
  </template>
<div :data-cotrustor-index="cotrustor.id">
  <v-text-field data-cotrustor="name"
    v-model="cotrustor.name" 
    label="Name" 
    required>
  </v-text-field>
  <v-text-field data-cotrustor="address"
    v-model="cotrustor.address" 
    label="Address" 
    required>
  </v-text-field>
  <v-text-field data-cotrustor="city"
    v-model="cotrustor.city" 
    label="City" 
    required>
  </v-text-field>
  <v-text-field data-cotrustor="country"
    v-model="cotrustor.country" 
    label="Country" 
    required>
  </v-text-field>
  <v-text-field data-cotrustor="phone"
    v-model="cotrustor.phone" 
    label="Phone" 
    required>
  </v-text-field>
  <v-text-field data-cotrustor="email"
    v-model="cotrustor.email" 
    label="Email" 
    required>
  </v-text-field>
</div>
</v-expansion-panel-content>
</v-flex>
</v-layout>
</template>

<script>
export default {
  data: () => ({}),
  props: ["cotrustor"],
  computed: {},
  methods: {
    deleteItem(cotrustor) {
      this.$emit("delete", cotrustor);
    }
  }
};
</script>

<style>
</style>
